import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { PhotoEditor } from '@capawesome/capacitor-photo-editor';
import { Filesystem } from '@capacitor/filesystem';
import { LoadingSpinnerComponent } from '../loading/loading-spinner/loading-spinner.component';
@Component({
  selector: 'app-cropper',
  templateUrl: './cropper.component.html',
  styleUrls: ['./cropper.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, LoadingSpinnerComponent],
})
export class CropperComponent implements AfterViewInit {
  @Input() imageBase64!: string;
  public base64String: any;
  loaded = false;

  constructor(private modalCtrl: ModalController) { }

  ngAfterViewInit(): void {
    if (this.imageBase64) {
      this.setBase64StringByPath(this.imageBase64);
    }
  }

  public async editPhoto(): Promise<void> {
    if (!this.imageBase64) {
      return;
    }

    await PhotoEditor.editPhoto({ path: this.imageBase64 });
    await this.setBase64StringByPath(this.imageBase64);
  }

  resizeBase64Image(base64: string): Promise<string> {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');

        if (!ctx) {
          resolve(base64);
          return;
        }

        ctx.drawImage(img, 0, 0);
        const resizedBase64 = canvas.toDataURL('image/png');
        resolve(resizedBase64);
      };
      img.src = base64;
    });
  }


  private async setBase64StringByPath(path: string): Promise<void> {
    const { data } = await Filesystem.readFile({ path });

    const resizedBase64 = await this.resizeBase64Image(`data:image/png;base64,${data}`);
    this.base64String = resizedBase64;

    setTimeout(() => (this.loaded = true), 1000);
  }

  save() {
    this.modalCtrl.dismiss(this.base64String);
  }

  cancel(): void {
    this.modalCtrl.dismiss(null);
  }
}
